// AbMapPickButton — kleine wiederverwendbare "im PDF waehlen"-Schaltflaeche (aktiv = amber,
// analog zur activeHighlightId-Farbe in AbPdfViewer). Erneuter Klick auf eine aktive Schaltflaeche
// deaktiviert den Pick-Modus wieder (Toggle). Gemeinsam genutzt von AbMapPositionsTab + AbMapFieldCard.

import React from 'react';
import { MousePointerClick } from 'lucide-react';

const AbMapPickButton = ({ isDarkMode, active, disabled, label, onClick }) => (
  <button
    type="button" disabled={disabled} onClick={onClick}
    className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-lg transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${active
      ? (isDarkMode ? 'bg-amber-500/20 text-amber-300 ring-1 ring-amber-400/50' : 'bg-amber-100 text-amber-700 ring-1 ring-amber-300')
      : (isDarkMode ? 'bg-white/10 text-white/70 hover:bg-white/15' : 'bg-slate-100 text-slate-600 hover:bg-slate-200')}`}
  >
    <MousePointerClick className="w-3.5 h-3.5" />
    {label}
  </button>
);

export default AbMapPickButton;
